import { connect, MapStateToProps } from 'react-redux';
import { Props } from './SubmissionDetails';
import { getIsCurrentUserAuthorOf } from '../redux/deviations/selectors';

export type StateProps = Pick<Props, 'isOwner'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state,
  { deviation }: OwnProps
) => ({
  isOwner: getIsCurrentUserAuthorOf(state, deviation),
});

export default connect(mapStateToProps);
